import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import * as d3 from "d3";
import { FeatureDataStateService } from "../../../core-module/services/state/feature-data-state.service";
import { drawDynaLineAndPath as _drawDynaLineAndPath } from "../../graph-utils/dyna-graph-common";
@Component({
  standalone: false,
  selector: "app-apm-dim-graph",
  templateUrl: "./apm-dim-graph.component.html",
  styleUrls: ["./apm-dim-graph.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApmDimGraphComponent implements OnInit {
  @Input() readOnly: boolean = true;

  inputXRange = [70, 277];

  inputYRange = [0, 100];

  data: LegacyAny[] = [
    { dyanXTime: 70, dyanYOutput: 50 },
    { dyanXTime: 110, dyanYOutput: 50 },
    { dyanXTime: 120, dyanYOutput: 90 },
    { dyanXTime: 277, dyanYOutput: 90 },
  ];
  data1: LegacyAny[] = [];
  dataFromTableValues: LegacyAny[] = [];

  focus;
  drag;
  public margin = { top: 50, right: 50, bottom: 50, left: 50 };
  public width: number;
  public height: number;
  public x: LegacyAny;
  public y: LegacyAny;
  public svg3: LegacyAny;
  public line: d3.Line<[number, number]>; // this is line defination
  public area: d3.area<[number, number]>; // this is area defination
  public id = "lineChart";
  public color2 = "#00b36b";
  newData: LegacyAny;
  changedPoint: LegacyAny;
  feedMaxValue: LegacyAny = 112;
  NormalLevelMaximum: LegacyAny;
  BackgroundLevelMaximum: LegacyAny;
  Maxdata: LegacyAny = [];
  Tmaxstart: LegacyAny;
  TmaxEnd: LegacyAny;
  TmaxShutDown: LegacyAny;
  scrolPoint: LegacyAny;
  deRatingdyanYOutput: LegacyAny;
  LamOffValue: LegacyAny;
  DtlDimStopValue: LegacyAny;
  TmaxdeRatingDim: LegacyAny;
  Forbidenarea: d3.area<[number, number]>; // this is area defination
  deratingLabelYaxis: number;
  TminEnd: LegacyAny;
  MaxLimit: LegacyAny;
  TmindeRatingDim: LegacyAny;
  graphEnabled: boolean;
  philipsLEDChecked: boolean;

  constructor(
    private featureData: FeatureDataStateService
  ) {}

  ngOnInit() {
    // this.dynaDimmer.getDynaTimeReferencedMode.subscribe(response => {

    //   if(response===true)
    //   {
    //     this.dynaDimmer.getFinalDynaDimmerData.subscribe(response=>{
    //       this.addDynaDetails(response);

    //     });
    //   }
    // })
    this.featureData.getAmpDimData.subscribe((response) => {
      this.data = this.addAmpDimData(response);

      this.buildSvg();
      this.addXandYAxis();
      this.drawLineAndPath();
      this.addDrag();
    });

    this.newData = this.data;

    this.buildSvg();
    this.addXandYAxis();
    this.drawLineAndPath();
    this.addDrag();
  }
  addAmpDimData(response: LegacyAny): LegacyAny[] {
    //let dataFromTable = JSON.parse(response);
    let isNoError: boolean = true;
    this.featureData.getampdimError.subscribe((response) => {
      if (response === false) {
        isNoError = true;
      }
    });
    if (isNoError) {
      const dimStopLevelCurrent =
        response.StopDimLevelValue > response.StopDimLevelMax
          ? response.StopDimLevelMax
          : response.StopDimLevelValue;
      const dimStartLevelCurrent =
        response.StartDimLevelValue > response.StartDimLevelMax
          ? response.StartDimLevelMax
          : response.StartDimLevelValue;

      const vMainsStopLevelCurrent =
        response.VmainsStopValue > response.VmainsStopMax
          ? response.VmainsStopMax
          : response.VmainsStopValue;
      const vMainsStartLevelCurrent =
        response.VmainsStartValue > response.VmainsStartMax
          ? response.VmainsStartMax
          : response.VmainsStartValue;

      return [
        { dyanXTime: 70, dyanYOutput: dimStopLevelCurrent },
        { dyanXTime: vMainsStopLevelCurrent, dyanYOutput: dimStopLevelCurrent },
        {
          dyanXTime: vMainsStartLevelCurrent,
          dyanYOutput: dimStartLevelCurrent,
        },
        {
          dyanXTime: response.VmainsStartMax,
          dyanYOutput: dimStartLevelCurrent,
        },
      ];
    }
  }

  public buildSvg() {
    this.svg3 = d3.select("#svg8");
    this.width = 960 - this.margin.left - this.margin.right;
    this.height = 500 - this.margin.top - this.margin.bottom;
  }
  public addXandYAxis() {
    // range of data configuring
    this.x = d3.scaleLinear().range([0, this.width]);
    this.y = d3.scaleLinear().range([this.height, 0]);
    this.x.domain(this.inputXRange);
    this.y.domain(this.inputYRange);
  }

  public drawLineAndPath() {
    // Delegated to shared dyna-graph-common.drawDynaLineAndPath.
    // apm-dim-graph-specific: #svg8 host, gradient2, x-label "Mains (V)" at x(180),
    // y-label "Light level (%)", xLabelYOffset -23.
    _drawDynaLineAndPath.call(this, {
      hostSvg: this.svg3,
      gradientId: "gradient2",
      xLabelAnchor: 180,
      clampY: false,
      svgSelector: "#svg8",
      xAxisLabel: "Mains (V)",
      yAxisLabel: "Light level (%)",
      xLabelYOffset: -23,
    });
  }

  // gridlines in x axis function
  make_x_gridlines() {
    return d3
      .axisBottom(this.x)
      .tickPadding(12)
      .ticks(21)
      .tickFormat(
        (d, i) =>
          [
            70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
            210, 220, 230, 240, 250, 260, 270, 277,
          ][i]
      );

    //tickFormat(x=>`(${x.toFixed(1)})`);
  }
  // gridlines in y axis function
  make_y_gridlines() {
    return d3.axisLeft(this.y).ticks(10);
  }
  public addDrag() {
    if (this.readOnly) {
      return;
    }
    const _this = this;
    const selection = this.focus.selectAll("circle").call(
      d3
        .drag()
        .on("start", function (event, d) {
          const control = _this.dragged();
          d["dyanXTime"] = control.x.invert(event.x);
          d["dyanYOutput"] = control.y.invert(event.y);
          const n = selection.nodes();
          const i = n.indexOf(this);
          const m = d3.select(n[i]).node();
          d3.select(m)
            .raise()
            .attr("cx", control.x(d.dyanXTime))
            .attr("cy", control.y(d.dyanYOutput));
          control.focus.select("path").attr("d", control.line);
        })
        .on("drag", function (event, d) {
          const control = _this.dragged();
          const n = selection.nodes();
          const i = n.indexOf(this);
          if (i >= 0 && i <= 4) {
            control.changedPoint = i;
            const m = d3.select(n[i]).node();
            if (control.changedPoint == 0) {
              d.dyanXTime = 70;
              d.dyanYOutput = control.y.invert(event.y);
              if (d.dyanYOutput < 10) d.dyanYOutput = 10;
              const twoPointX = control.data[1].dyanXTime;
              const threePointX = control.data[2].dyanXTime;
              const threePointY = control.data[2].dyanYOutput;
              if (d.dyanXTime >= threePointX) d.dyanXTime = threePointX;
              if (d.dyanYOutput >= threePointY) d.dyanYOutput = threePointY;
              const drag3Pt = d3.select(n[1]).node();
              d3.select(drag3Pt)
                .attr("cx", control.x(twoPointX))
                .attr("cy", control.y(d.dyanYOutput));
              control.focus.select("path").attr("d", control.area);
              control.focus.select("path").attr("d", control.line);
              control.data[1].dyanXTime = twoPointX;
              control.data[1].dyanYOutput = d.dyanYOutput;
            }
            if (control.changedPoint == 1) {
              d.dyanXTime = control.x.invert(event.x);
              d.dyanYOutput = control.y.invert(event.y);
              if (d.dyanXTime >= 230) d.dyanXTime = 230;
              if (d.dyanXTime <= 70) d.dyanXTime = 70;
              if (d.dyanYOutput >= 100) d.dyanYOutput = 100;
              if (d.dyanYOutput <= 10) d.dyanYOutput = 10;
              const threePointX = control.data[2].dyanXTime;
              const threePointY = control.data[2].dyanYOutput;
              if (d.dyanXTime >= threePointX) d.dyanXTime = threePointX;
              if (d.dyanYOutput >= threePointY) d.dyanYOutput = threePointY;
              const drag1Pt = d3.select(n[0]).node();
              d3.select(drag1Pt)
                .attr("cx", control.x(70))
                .attr("cy", control.y(d.dyanYOutput));
              control.focus.select("path").attr("d", control.area);
              control.focus.select("path").attr("d", control.line);
              control.data[0].dyanYOutput = d.dyanYOutput;
            }
            if (control.changedPoint == 2) {
              d.dyanXTime = control.x.invert(event.x);
              d.dyanYOutput = control.y.invert(event.y);
              if (d.dyanYOutput <= 30) d.dyanYOutput = 30;
              if (d.dyanYOutput >= 100) d.dyanYOutput = 100;
              if (d.dyanXTime > 277) d.dyanXTime = 277;
              const twoPointX = control.data[1].dyanXTime;
              const twoPointY = control.data[1].dyanYOutput;
              if (d.dyanXTime <= twoPointX) d.dyanXTime = twoPointX;
              if (d.dyanYOutput <= twoPointY) d.dyanYOutput = twoPointY;
              const drag3Pt = d3.select(n[3]).node();
              d3.select(drag3Pt)
                .attr("cx", control.x(277))
                .attr("cy", control.y(d.dyanYOutput));
              control.focus.select("path").attr("d", control.area);
              control.focus.select("path").attr("d", control.line);
              control.data[3].dyanYOutput = d.dyanYOutput;
            }
            if (control.changedPoint == 3) {
              d.dyanXTime = 277;
              d.dyanYOutput = control.y.invert(event.y);
              if (d.dyanYOutput <= 30) d.dyanYOutput = 30;
              if (d.dyanYOutput >= 100) d.dyanYOutput = 100;
              if (d.dyanXTime > 277) d.dyanXTime = 277;
              const twoPointX = control.data[1].dyanXTime;
              const twoPointY = control.data[1].dyanYOutput;
              if (d.dyanXTime <= twoPointX) d.dyanXTime = twoPointX;
              if (d.dyanYOutput <= twoPointY) d.dyanYOutput = twoPointY;
              const threePointX = control.data[2].dyanXTime;
              const drag2Pt = d3.select(n[2]).node();
              d3.select(drag2Pt)
                .attr("cx", control.x(threePointX))
                .attr("cy", control.y(d.dyanYOutput));
              control.focus.select("path").attr("d", control.area);
              control.focus.select("path").attr("d", control.line);
              control.data[2].dyanYOutput = d.dyanYOutput;
            }
            d3.select(m)
              .attr("cx", control.x(d.dyanXTime))
              .attr("cy", control.y(d.dyanYOutput));
            control.focus.select("path").attr("d", control.area);
          }
        })
        .on("end", this.dragended.bind(this))
    );
  }

  dragstarted(d) {}

  public dragged() {
    return this;
  }
  public dragended(d) {
    this.featureData.sendAmpDimGraphdata(this.data);
  }
}

